export const calcProtectPlanSavedAmts = (savedTrans, addTrans) => {

    let savedAmt = 0;
    let combineTranArr = [];
    let deleteIndxArr = [];
    for (let i=0; i<addTrans.length; i++){
        for (let j=0; j<savedTrans.length; j++){
            const savedTran = savedTrans[j];
            if (savedTran.protectPlanType === addTrans[i].protectPlanType &&
                savedTran.planName === addTrans[i].planName){
                    if (savedTran.tranDate >= addTrans[i].addFirstDate && 
                        savedTran.tranDate <= addTrans[i].addLastDate){
                            savedAmt += +savedTran.tranAmount;
                        deleteIndxArr.push(j);
                    }
            }else{
                    if (savedAmt > 0){
                        addTrans[i].totalSaved = savedAmt;
                        savedAmt = 0;
                    }
            }
        }
        if (savedAmt > 0){
            addTrans[i].totalSaved = savedAmt;
            savedAmt = 0;
        }
        const maxIndx = deleteIndxArr.length - 1;
        for (let j=maxIndx; j>=0; j--){
            const deleteIndx = deleteIndxArr[j];
            savedTrans.splice(deleteIndx, 1);
        }
        deleteIndxArr = [];
        savedAmt = 0;
    }
    //  if all is working as expected, the savedTrans array should be empty
    const returnObj = {totalAmtsArr: addTrans, orphanTransArr: savedTrans};
    return returnObj;

}
export default calcProtectPlanSavedAmts;
